/**
 * Created by Mike Naughton on 3/13/18.
 *
 * Class which wraps the Graphic class of ESRI
 */

import Feature from "./Feature";
import _ from "underscore";
import FeatureData from "./FeatureData";
import Geometry from "./map/Geometry";
import Backbone from "backbone";
import s from "underscore.string";
import urlService from "app/UrlService";
import DocumentCollection from "./DocumentCollection";

export default Feature.extend({
  urlRoot: function () {
    return "";
  },

  defaults: function () {
    return {};
  },

  /**
   * Initializes the ExternalFeature
   * @param {Graphic} attributes The ESRI Graphic to wrap with this class.
   * @param {Object} options A hash of options
   * @param {FeatureLayer} options.layer The layer associated with this feature.
   */
  initialize: function (attributes, options) {
    Backbone.Model.prototype.initialize.call(this, {}, options);

    this.options = _.defaults({}, options);
    this.graphic = attributes;
    this.layer = this.options.layer;
    this.idAttribute = this.layer.objectIdField;
    this.set(this.graphic.attributes);
    this.originalLayer = this.layer;
    this.graphic._feature = this;
  },

  toJSON: function () {
    return this.graphic.toJson();
  },

  getLayer: function () {
    return this.options.layer;
  },

  /**
   * Gets the geometry object associated with this feature. Changes of the "geometry" attribute of this model reflect to the returned geometry model and vice versa.
   * @returns {app/models/map/Geometry} The geometry object.
   */
  getGeometry: function () {
    if (!this._geometry) {
      this._geometry = new Geometry(
        {},
        {
          feature: this,
        }
      );
      this._geometry.parseEsriGeometry(this.graphic.geometry);
    }

    return this._geometry;
  },

  setGeometry: function () {
    console.warn("Geometry cannot be set on an external feature");
  },

  /**
   * Gets the properties object associated with this feature, wrapped as a Backbone model.
   * @returns {app/models/FeatureData} The data object.
   */
  getProperties: function () {
    if (!this._properties) {
      this._properties = new FeatureData(this.graphic.attributes, {
        feature: this,
      });
    }

    return this._properties;
  },

  /**
   * Gets the attribute associated with the feature. If the value isn't found in the attributes section, looks through the attributes.properties section where data is stored sometimes.
   * @param {string} attribute The string of the attribute to look for..
   */
  get: function (attribute) {
    return this.getProperties().get(attribute);
  },

  setProperties: function () {
    console.warn("Properties cannot be set on an external feature");
  },

  /**
   * Gets the id of this feature.
   * @returns {*} The feature id
   */
  featureId: function () {
    return this.layer.getId(this.graphic);
  },

  /**
   * Gets the collection of documents associated with this feature.
   * @return {app/models/DocumentCollection} The document collection.
   */
  getDocuments: function () {
    if (!this._documents) {
      this._documents = new DocumentCollection(null, {
        url: this.getDocumentsUrl(),
      });
    }

    return this._documents;
  },

  /**
   * Gets the documents URL associated with this feature.
   * @return {String} The documents URL.
   */
  getDocumentsUrl: function () {
    var result = null;
    var layer = this.layer;

    var field = layer.getField(layer.serviceLayer.service.get("directoryKey"));

    if (field) {
      var value = field.getValue(this);

      if (value) {
        if (!s.endsWith(value, "/")) {
          value = value + "/"; //make sure the server thinks we're a directory
        }

        result =
          urlService.apiurl("/document") +
          "?service=" +
          layer.serviceLayer.service.id +
          "&url=" +
          encodeURIComponent(value);
      }
    }

    return result;
  },

  isExternal: function () {
    return true;
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/ExternalFeature.js
// module id = 505
// module chunks = 1